import { userRoles } from '../constants/user-roles';
import { UserRoleCatalog, UserRoleEntry, UserRoles } from '../types/user-roles';

export const findUserRoleEntryByRoleId = (roleId: number): UserRoleEntry<UserRoles> | undefined => {
  for (const userRole of Object.values(userRoles)) {
    if (userRole.roleId === roleId) {
      return userRole;
    }
  }
  return undefined;
};

export const getInvitationRoles = (
  invitationRoles: Partial<Pick<UserRoleCatalog, UserRoles.MANAGER | UserRoles.USER>>,
  isOwner: boolean,
  securityLevelId: number,
) => {
  if (isOwner || !securityLevelId) {
    return invitationRoles;
  }

  const filteredRoles = Object.keys(invitationRoles).reduce(
    (accumulator, role) => {
      const typedRole = role as keyof typeof invitationRoles;
      const roleDetails = invitationRoles[typedRole];

      // Allow user to invite roleId greater than to current securityLevelId(roleId)
      if (roleDetails && roleDetails?.roleId > securityLevelId) {
        // Disabled es-lint since the type of accumulator changes dynamically
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (accumulator as any)[typedRole] = roleDetails;
      }
      return accumulator;
    },
    {} as Partial<typeof invitationRoles>,
  );

  return filteredRoles;
};
